import type { Cue } from "./cue";

interface TimelineNode {
  /** `Cue.idPathParts` の1要素（例: `1`（見出し）、`1-2`（本文）。表示用の `cueTitle` ではない） */
  segment: string;
  children: TimelineNode[];
  /** 葉ノードのみ */
  cue?: Cue;
  minStart: number;
}

const buildTimelineTree = (cues: readonly Cue[]): TimelineNode => {
  const root: TimelineNode = {
    segment: "",
    children: [],
    minStart: Number.POSITIVE_INFINITY,
  };
  cues.forEach((cue, i) => {
    _insertCue(root, _segmentsFromCueId(cue, i), cue);
  });
  return root;
};

const _segmentsFromCueId = (cue: Cue, idx: number): string[] =>
  cue.idPathParts.length > 0 ? [...cue.idPathParts] : [`cue_${idx}`];

const _insertCue = (root: TimelineNode, segments: string[], cue: Cue): void => {
  root.minStart = Math.min(root.minStart, cue.startTime);
  if (segments.length === 0) {
    root.cue = cue;
    return;
  }

  const [head, ...rest] = segments;
  let child = root.children.find((c) => c.segment === head);
  if (!child) {
    child = { segment: head, children: [], minStart: cue.startTime };
    root.children.push(child);
  }
  _insertCue(child, rest, cue);
};

export { type TimelineNode, buildTimelineTree };
